import { Box, Text } from '@chakra-ui/react'
import React from 'react'

export default function SraList({title, details}) {
  return (
    <Text textTransform={"capitalize"} color={"black"} fontSize="15" fontWeight={"500"}>{title} <Box as="span" fontWeight={"400"}>{details}</Box></Text>

  )
}
